import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import BootstrapLoadingButton from "../../../components/Ui/BootstrapLoadingButton";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import DonneeTechniqueForm from "../../../components/Forms/Confirgurations/DonneeTechniqueForm";
import moment from "moment";
import {Link} from "react-router-dom";
import Pagination from "@material-ui/lab/Pagination";
import {BASE_DONNEE_TECHNIQUE} from "../../../api/Api";
import axios from 'axios'
import ConfirmationModal from "../../../components/Modals/ConfirmationModal";
import {toast} from "react-toastify";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto',
    },
    locationItem: {
        '&': {
            opacity: 0.3
        },
        '&.active': {
            opacity: 1
        },
        '&:hover': {
            opacity: 1
        },
    },
    table: {
        minWidth: 700,
    },
}));

const DonneeTechniqueTypeInfo = {

    nature_travaux: {
        hasSociete: true
    },
    technique_travaux: {
        defaultSociete: 'cie',
        hasSociete: false

    },
    type_client: {
        defaultSociete: 'cie',
        hasSociete: false

    },
    moyens_utilise: {
        defaultSociete: 'cie',
        hasSociete: false

    }

};

export default function DonneTechniquePage(props) {

    const classes = useStyles();

    const [selectedData, setSelectedData] = React.useState()

    const [searchResultPagined,setSearchResultPagined] = React.useState({});
    const [searchResultPageState,setSearchResultPageState] = React.useState({currentPage:0,totalPages:0})

    const [modelUnderEdition,setModelUnderEdition] = React.useState()

    const currentItems = React.useMemo(
        () => {
            return searchResultPagined[searchResultPageState.currentPage] || [];
        },[searchResultPageState.currentPage,searchResultPagined]
    );

    const currentDataInfos = React.useMemo(
        () => {
            return DonneeTechniqueTypeInfo[selectedData] || {};
        },[selectedData]
    );

    React.useEffect(
        () => {

            setSearchResultPageState({currentPage: 0,totalPages: 0})
            setSearchResultPagined({})

            if(selectedData)
                loadPage(1,true)

        },[selectedData]
    );

    async function loadPage(page = 1,forceReload = false){

        if(!selectedData)
            return;

        if(searchResultPagined[page] && !forceReload){
            // console.log('reinitialisation du formulaie',page)
            setSearchResultPageState({...searchResultPageState,currentPage:page})
            return;
        }

        try{

            const response = await axios.get(
                BASE_DONNEE_TECHNIQUE,
                {
                    params: {
                        type: selectedData,
                        page
                    }
                }
            );


            const {total: count,current_page,last_page: totalPages,data} = response.data;

            console.log('searchResponse',response);

            setSearchResultPagined({
                ...searchResultPagined,
                [page]: (data)
            })

            setSearchResultPageState({
                currentPage: current_page,
                totalPages,
                count
            })


        } catch (e) {
            
          toast.error('Une erreur s\'est produite', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

    } finally {

        }


    }

    function onPageChange(event,page){
        if(loadPage)
            loadPage(page);
    }

    async function store(values,formikHelpers){

        try{

            await axios.post(
                BASE_DONNEE_TECHNIQUE,
                {
                    libelle: values.libelle,
                    societe: values.societe ? values.societe : undefined,
                    type: selectedData
                }
            );

            loadPage(1,true)

          toast.success('Donnée ajoutée avec succès', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });


        } catch (e) {

          toast.error('Une erreur s\'est produite', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });        } finally {
            formikHelpers.setSubmitting(false)
        }


    }

    async function update(values,formikHelpers){

        try{

            await axios.patch(
                BASE_DONNEE_TECHNIQUE,
                {
                    libelle: values.libelle,
                    societe: values.societe ? values.societe : undefined,
                    id: modelUnderEdition.id,
                    type: selectedData
                }
            );

            loadPage(1,true)
            setModelUnderEdition()

          toast.success('Donnée modifier avec succès', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });


        } catch (e) {

            toast.error('Une erreur s\'est produite', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
                } finally {
            formikHelpers.setSubmitting(false)
        }


    }

    async function remove(model){

        try{

            await axios.delete(
                BASE_DONNEE_TECHNIQUE,
                {
                    params: {
                        type: selectedData,
                        id: model.id
                    }
                }
            );

            loadPage(1,true)
            
            toast.success('Donnée modifier avec succès', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });  
            

        } catch (e) {

            toast.error('Une erreur s\'est produite', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });        
        } finally {
        }


    }


    return (
        <div>


            <div>
                <div className={`card card-custom`}>

                    <div className="card-header border-0">
                        <h3 className="card-title font-weight-bolder text-dark text-gray">
                            Configuration des données techniques


                        </h3>
                        <div className="card-toolbar">

                            <TextField
                                select
                                style={{minWidth: 320}}
                                value={selectedData}
                                onChange={(e) => {
                                    setSelectedData(e.target.value)
                                    console.log('new values',e.target.value);
                                }}
                            >

                                <MenuItem value={'type_client'}>
                                    Types de client
                                </MenuItem>
                                <MenuItem value={'nature_travaux'}>
                                    Natures de travaux
                                </MenuItem>
                                <MenuItem value={'technique_travaux'}>
                                    Techniques de travaux
                                </MenuItem>
                                <MenuItem value={'moyens_utilise'}>
                                    Moyens utilisés
                                </MenuItem>

                            </TextField>

                        </div>
                    </div>


                    <div
                        className="card-body pt-2">

                        <div>
                            Vous pouvez ajouter modifier et supprimer les données techniques
                        </div>

                        {
                            selectedData && (

                                <div>

                                    <div className={'my-3'}>

                                        {
                                            modelUnderEdition && (

                                                <div onClick={()=>{
                                                    setModelUnderEdition()
                                                }} className="btn btn-light-danger">
                                                    annuler la modification
                                                </div>

                                            )
                                        }

                                        <DonneeTechniqueForm
                                            onUpdate={update}
                                            modelUnderEdition={modelUnderEdition} initialValues={
                                            modelUnderEdition ? {libelle: modelUnderEdition.libelle,societe: modelUnderEdition.societe} : {libelle: '', societe: ''}
                                        } onSubmit={store} hasSociete={currentDataInfos.hasSociete} />
                                    </div>


                                    <div className=" position-relative overflow-hidden">

                                        <table className="table table-borderless table-vertical-center">
                                            <thead>
                                            <tr className={'bg-primary text-white text-center'}>
                                                <th className="py-4">Libelle</th>

                                                {currentDataInfos.hasSociete && (
                                                    <th className="p-0" >Societe</th>
                                                )}

                                                <th className="p-0" >Actions</th>
                                            </tr>
                                            </thead>
                                            <tbody className={`${classes.tableBody} text-center`}>

                                            {
                                                currentItems.map(
                                                    item => {
                                                        return (
                                                            <tr className={` ${classes.abonnementItem}`} key={item.id}>
                                                                <td className="pl-0">
                                                                    {item.libelle}
                                                                </td>

                                                                {currentDataInfos.hasSociete && (
                                                                    <td className="pl-0">
                                                                        {item.societe || 'cie & sodeci'}
                                                                    </td>
                                                                )}
                                                                <td className="pl-0">
                                                                    <div onClick={()=> {
                                                                        setModelUnderEdition(item)
                                                                    }} className="btn btn-icon btn-light-primary mr-2">
                                                                        <i className="flaticon2-edit"></i>
                                                                    </div>

                                                                    <ConfirmationModal onConfirm={()=>{
                                                                        remove(item)
                                                                    }} title={'Confirmation'} text={'Êtes vous sûr de vouloir supprimer cette entrée ?'}>
                                                                        <div className="btn btn-icon btn-light-primary mr-2">
                                                                            <i className="flaticon2-delete"></i>
                                                                        </div>
                                                                    </ConfirmationModal>


                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                )
                                            }

                                            </tbody>

                                            {
                                                searchResultPageState.count == 0 && (
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan={3}>
                                                                <div className={'my-5 py-5 text-center'}>
                                                                    Aucun enregistrement pour l'instant
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                )
                                            }

                                        </table>

                                        {/*<div className={'position-relative'}>*/}

                                        {/*    <Pagination color={'primary'} count={searchResultPageState.totalPages} page={searchResultPageState.currentPage} onChange={onPageChange} />*/}

                                        {/*    {*/}
                                        {/*         isLoadingPage  && (*/}
                                        {/*        <div className={classes.overlay}>*/}
                                        {/*            <CircularProgress size={16} disableShrink />*/}
                                        {/*        </div>*/}
                                        {/*    )*/}
                                        {/*    }*/}

                                        {/*</div>*/}

                                    </div>

                                </div>

                            )
                        }

                    </div>

                </div>
            </div>


        </div>
    );
}